import { IgTextField } from "@intelligems/ig-theme";
import {
  ChannelType,
  DeviceType,
  ExpressionNodeQueryType,
  VisitorType,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { ChannelSelect } from "@src/components/AudienceFilters/Channel";
import { CountrySelect } from "@src/components/AudienceFilters/Country";
import { DeviceSelect } from "@src/components/AudienceFilters/Device/DeviceSelect";
import { VisitorSelect } from "@src/components/AudienceFilters/Visitor";

import { JavascriptValue } from "./JavascriptValue";
import { RegexpValue } from "./RegexpValue";
import { UrlValue } from "./UrlValue";
import type { UpdateExpressionNodeQueryType } from "./utils";

interface ConditionValueProps {
  tempExpressionQuery: ExpressionNodeQueryType;
  onChange: UpdateExpressionNodeQueryType;
}

export const ConditionValue = ({
  tempExpressionQuery,
  onChange,
}: ConditionValueProps) => {
  if (tempExpressionQuery.type === "device") {
    return (
      <DeviceSelect
        deviceType={tempExpressionQuery.value as DeviceType}
        onChange={onChange}
      />
    );
  }
  if (tempExpressionQuery.type === "visitor") {
    return (
      <VisitorSelect
        visitorType={tempExpressionQuery.value as VisitorType}
        onChange={onChange}
      />
    );
  }
  if (tempExpressionQuery.type === "trafficSource") {
    return (
      <ChannelSelect
        channelType={tempExpressionQuery.value as ChannelType}
        onChange={onChange}
      />
    );
  }
  if (tempExpressionQuery.type === "country") {
    return (
      <CountrySelect country={tempExpressionQuery.value} onChange={onChange} />
    );
  }
  if (tempExpressionQuery.type === "jsExpression") {
    return (
      <JavascriptValue value={tempExpressionQuery.value} onChange={onChange} />
    );
  }
  if (
    tempExpressionQuery.type === "landingPage" &&
    (tempExpressionQuery.filter === "equals" ||
      tempExpressionQuery.filter === "doesNotEqual")
  ) {
    return <UrlValue value={tempExpressionQuery.value} onChange={onChange} />;
  }
  if (
    tempExpressionQuery.filter === "isNull" ||
    tempExpressionQuery.filter === "isNotNull"
  ) {
    return null;
  }

  if (tempExpressionQuery.filter === "regex") {
    return (
      <RegexpValue value={tempExpressionQuery.value} onChange={onChange} />
    );
  }

  return (
    <Grid item flexGrow={1}>
      <IgTextField
        fullWidth={true}
        value={tempExpressionQuery.value || ""}
        onChange={(e) => {
          onChange(e.target.value || "", "value");
        }}
      />
    </Grid>
  );
};
